export const profile = ({ $store }) => $store.getters["user/getProfile"];

export const authToken = ({ $store }) => $store.state.auth.token;

export default { profile, authToken };
